import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, shortDateTime } from "../../utils/const";
import { Icon } from "@iconify/react/dist/iconify.js";
import { styled } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { getCandidateList } from "../../redux/hotlist/hotListSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../redux/common/locationSlice";
import JobSendDrawer from "./JobSendDrawer";
import HotListMsgDrawer from "./HotListMsgDrawer";

const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#d0d0f0",
  },
}));

const ViewHotlistDrawer = ({ show, handleClose, hotlist, hotProfile }) => {
  const dispatch = useDispatch();
  const [showDrawer, setShowDrawer] = useState(false);
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [selectedHotlist, setSelectedHotlist] = useState(null);
  const candidateList = useSelector((state) => state.hotlist.candidates);
  const candidateListLoading = useSelector(
    (state) => state.hotlist.loading.getCandidateList
  );
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];

  useEffect(() => {
    if (hotlist?.id) {
      dispatch(getCandidateList(hotlist.id));
    }
  }, [dispatch, hotlist?.id]);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, [dispatch]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name || "N/A";
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name || "N/A";
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
    setSelectedHotlist(null);
  };

  const handleOpenMsgDrawer = (hotlist) => {
    setSelectedHotlist(hotlist);
    setShowMsgDrawer(true);
  };

  const handleCloseMsgDrawer = () => {
    setShowMsgDrawer(false);
    setSelectedHotlist(null);
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "50%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
              mb: "10px",
            }}
          >
            <Typography variant="h6" style={{ color: customTextColor }}>
              Consultants - {hotlist?.name} |{" "}
              {shortDateTime(hotlist?.updated_at)}
            </Typography>
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </Box>
          {candidateListLoading === "pending" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2,
                py: 5,
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box sx={{ padding: "0px 10px" }}>
              {/* Candidate Items */}
              <Box>
                {candidateList?.length > 0 ? (
                  candidateList?.map((candidate) => (
                    <Box
                      key={candidate.candidateId}
                      sx={{
                        padding: "5px 10px",
                        border: "1px solid #e0e0e0",
                        mb: "10px",
                        borderRadius: "3px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="body1">
                          <b>{candidate?.full_name || "N/A"}</b> -{" "}
                          {getWorkAuthorization(
                            candidate?.work_authorization
                          ) || "N/A"}
                        </Typography>
                        <Typography variant="body1">
                          {candidate?.current_job_title || "N/A"} -{" "}
                          {candidate.total_experience < 1
                            ? `${Math.round(
                                candidate.total_experience * 12
                              )} Months`
                            : `${candidate.total_experience} ${
                                candidate.total_experience === 1
                                  ? "Year"
                                  : "Years"
                              }`}
                        </Typography>
                        <Typography variant="body2">
                          Live in{" "}
                          {getLocationById(candidate?.current_location) ||
                            "N/A"}
                        </Typography>
                        <Typography variant="body2">
                          {candidate?.willing_to_relocate
                            ? "Will to Relocate"
                            : "Not Relocate "}
                        </Typography>

                        <Typography variant="body2">
                          Rate $
                          {(candidate.rate && `${candidate.rate} Hourly `) ||
                            "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          gap: 3,
                        }}
                      >
                        {candidate?.resume ? (
                          <ActionButton
                            color="inherit"
                            onClick={() =>
                              window.open(
                                candidate?.resume,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                            sx={{
                              backgroundColor: "#deebf7",
                              borderRadius: "3px",
                              padding: "3px",
                              "&:hover": {
                                backgroundColor: "#33a8c7",
                              },
                            }}
                          >
                            <Icon
                              icon="material-symbols-light:docs-outline-rounded"
                              width="25px"
                              height="25px"
                              color="black"
                            />
                          </ActionButton>
                        ) : (
                          "Resume Not Available"
                        )}

                        <Button
                          variant="contained"
                          onClick={() => handleOpenMsgDrawer(candidate)}
                          sx={{
                            backgroundColor: "#00b0f0",
                            textTransform: "capitalize",
                            borderRadius: "3px",
                            padding: "5px 10px",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: "#0085b4",
                              boxShadow: "none",
                            },
                          }}
                        >
                          Request{" "}
                          <Icon
                            icon="lucide:send"
                            width="15"
                            height="15"
                            style={{ marginLeft: "2px" }}
                          />
                        </Button>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Typography
                    variant="body2"
                    style={{ color: customTextColor }}
                  >
                    No candidates available.
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </Box>
        {showDrawer && (
          <JobSendDrawer
            show={showDrawer}
            handleClose={handleCloseDrawer}
            candidate={selectedHotlist}
            hotlist={hotlist}
          />
        )}
        {showMsgDrawer && (
          <HotListMsgDrawer
            open={showMsgDrawer}
            onClose={handleCloseMsgDrawer}
            candidate={selectedHotlist}
            hotlist={hotlist}
            hotProfile={hotProfile}
          />
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewHotlistDrawer;
